export enum ServiceCode {
  DrugDOTUrine = "DOTU",
  DrugDOTOral = "DOTSL",
  DrugNonDOTUrine = "NDOTU",
  DrugNonDOTOral = "SDRG",
  AlcoholBreath = "BALC",
  AlcoholSaliva = "SALC",
  AlcoholBreathDOT = "DOTBALC",
  AlcoholSalivaDOT = "DOTSALC",
  PhysicalDOT = "DOTPHY",
  Physical = "FFPPE",
  POCT = "IDRUG",
  FLEX = "FLEX",
  Audiogram = "AUDIOGRAM",
  Clinical = "CLINICAL",
  COVID = "COVID",
  Pulmonary = "PULMONARY",
  RespiratorFit = "RESPIRATOR",
  RespiratorMedical = "RESPMEQ",
  Tuberculosis = "TBSKIN",
  Wellness = "WELLNESS",
  Hair = "HAIR",
  None = "",
}
